import Amplify, { Auth, Storage } from 'aws-amplify';
import uuid from 'uuid';
import loadImage from 'blueimp-load-image';
import { logout } from '../libs/apis/AccountApi';

const identityPoolId = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;
const region = process.env.REACT_APP_AWS_REGION;
const userPoolId = process.env.REACT_APP_AWS_USER_POOL_ID;
const userPoolWebClientId = process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID;
const bucket = process.env.REACT_APP_AWS_S3_BUCKET_NAME;
const bucketReport = process.env.REACT_APP_AWS_S3_BUCKET_NAME_REPORT;

Amplify.configure({
  Auth: {
    identityPoolId,
    region,
    userPoolId,
    userPoolWebClientId
  },
  Storage: {
    AWSS3: {
      bucket,
      region
    }
  }
});

// SignUp
export const signUp = async (username, password) => {
  return Auth.signUp({
    username,
    password,
    attributes: {
      // email,
      // phone
      // other custom attributes
    },
    validationData: [] // optional
  });
};

export const confirmSignUp = (username, code) => {
  // After retrieving the confirmation code from the user
  return Auth.confirmSignUp(username, code, {
    // Optional. Force user confirmation irrespective of existing alias. By default set to True.
    forceAliasCreation: true
  });
};

export const resendSignUp = email => {
  return Auth.resendSignUp(email);
};

export const signIn = (username, password) => {
  return Auth.signIn(username, password);
};

export const signOut = async () => {
  await Auth.signOut();
  await logout()
    .then(response => {
      console.log('logout====>', response.data.cognitoUserId);
    })
    .catch(error => {
      console.log('error logout====>', error.message);
    });
};

export const sendLogin = props => {
  alert('セッションが切れました。\n再度ログインしてください。');
  props.history.push('/');
};

export const isAuthenticated = async props => {
  try {
    const cognitoUserId = localStorage.getItem('cognitoUserId');
    // eslint-disable-next-line no-param-reassign
    if (!cognitoUserId) {
      await Auth.currentAuthenticatedUser();
    }
  } catch (err) {
    alert('セッションが切れました。\n再度ログインしてください。');
    props.history.push('/');
  }
};

export const getCurrentUser = () => {
  return Auth.currentAuthenticatedUser();
};

export const getCurrentSession = () => {
  return Auth.currentSession();
};

export const getCurrentUserInfo = () => {
  return Auth.currentUserInfo();
};

export const setPreferredMFA = (user, type) => {
  return Auth.setPreferredMFA(user, type);
};

export const updatePhone = (user, phone) => {
  return Auth.updateUserAttributes(user, {
    phone_number: phone
  });
};

export const verifyPhone = user => {
  return Auth.verifyUserAttribute(user, 'phone_number');
};

export const verifyPhoneSubmit = (user, code) => {
  return Auth.verifyUserAttributeSubmit(user, 'phone_number', code);
};

export const changeEmalAddress = async newEmailAddress => {
  const user = await Auth.currentAuthenticatedUser();
  return Auth.updateUserAttributes(user, {
    email: newEmailAddress
  });
};

export const verifyEmailSubmit = code => {
  return Auth.verifyCurrentUserAttributeSubmit('email', code);
};

export const changePassword = async (oldPassword, newPassword) => {
  const user = await Auth.currentAuthenticatedUser();
  await Auth.changePassword(user, oldPassword, newPassword);
};

export const forgotPassword = username => {
  return Auth.forgotPassword(username);
};

export const forgotPasswordSubmit = (username, code, password) => {
  console.log('forgotPasswordSubmit ===>', username);
  console.log('code ===>', code);
  console.log('password ===>', password);
  return Auth.forgotPasswordSubmit(username, code, password);
};

const toBlob = (base64, fileName, reject) => {
  const bin = atob(base64.replace(/^.*,/, ''));
  const buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) {
    buffer[i] = bin.charCodeAt(i);
  }

  try {
    const blob = new Blob([buffer.buffer], {
      type: 'image/*'
    });
    blob.name = fileName;
    return blob;
  } catch (e) {
    reject();
    return false;
  }
};

export const resizeImage = image => {
  return new Promise((resolve, reject) => {
    loadImage.parseMetaData(image, data => {
      const options = {
        maxWidth: process.env.REACT_APP_RESIZE_MAX_WIDTH,
        canvas: true
      };
      if (data.exif) {
        options.orientation = data.exif.get('Orientation');
      }
      loadImage(
        image,
        canvas => {
          const imageUri = canvas.toDataURL('image/*');
          const resizeImageFile = toBlob(imageUri, image.name, reject);
          resolve({
            resizeImageFile
          });
        },
        options
      );
    });
  });
};

export const resizeImageGiftCard = image => {
  return new Promise((resolve, reject) => {
    loadImage.parseMetaData(image, data => {
      const options = {
        maxWidth: process.env.REACT_APP_MAX_WIDTH_ALLOW,
        maxHeight: process.env.REACT_APP_MAX_HEIGHT_ALLOW,
        canvas: true,
        meta: true
      };
      if (data.exif) {
        options.orientation = data.exif.get('Orientation');
      }
      loadImage(
        image,
        canvas => {
          const imageUri = canvas.toDataURL('image/*');
          const resizeImageFile = toBlob(imageUri, image.name, reject);
          resolve({
            resizeImageFile
          });
        },
        options
      );
    });
  });
};

export const uploadFile = (path, id, file, access) => {
  const filepath = `images/${path}/${id}/`;

  const key = `${filepath}${uuid.v4()}.${file.name.split('.').pop()}`;
  const options = {
    level: access,
    contentType: 'image/*'
  };

  return Storage.put(key, file, options).then(
    data => process.env.REACT_APP_AWS_CLOUD_FRONT_PATH + data.key
  );
};

export const uploadFileCsv = (path, file, access) => {
  const filepath = `${path}/`;

  const key = `${filepath}${uuid.v4()}.${file.name.split('.').pop()}`;
  const options = {
    level: access,
    bucket: bucketReport
  };

  // console.log('binhd222', key);
  return Storage.put(key, file, options).then(data => {
    return `public/${data.key}`;
  });
};
